// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"search_searchContainer__3hvbv","searchIcon":"search_searchIcon__31CUS"};